module.exports = __webpack_public_path__ + "static/img/exercise_session_wait_for_live_participants.17fcfa5d.svg";